import React, { useState, useEffect, useRef } from "react";
import axios, { all } from "axios";
import "./businessPlanning.css";

import { BusinessPlanState } from "../../context/BusinessPlanningContext";
import { GlobalState } from "../../context/GlobalContext";
import BrandLevelBp from "./StoresTable/StoresTable";
import CreateBusinessPlan from "./CreateBusinessPlan/CreateBusinessPlan";
import CircularProgressWithLabel from "../ReusableComponents/CircularProgressWithLabel";

import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import Store from "./Store/Store";
import StoresTable from "./StoresTable/StoresTable";
import { Popper } from "@mui/material";
import { InLakhsDisplay } from "components/ReusableComponents/InLakhsDisplay";
import { AuthState } from "context/AuthContext";
import { custom } from "data/authData";

const bpTablecolumns = [
	{ field: "name", headerName: "BUSINESS PLAN", minWidth: 130, flex: 1, headerAlign: "center", align: "center" },
	{
		field: "channel",
		headerName: "CHANNEL",
		headerAlign: "center",
		align: "center",
		minWidth: 100,
		flex: 1,
		renderCell: (params) => {
			return <>{params.row.channel}</>;
		},
	},
	{ field: "total_count", headerName: "STORE COUNT", minWidth: 110, flex: 1, headerAlign: "center", align: "center" },
	{ field: "total_qty", headerName: "TOTAL QTY", minWidth: 100, flex: 1, headerAlign: "center", align: "center" },
	{
		field: "new_dis",
		headerName: "DISCOUNT",
		minWidth: 100,
		flex: 1,
		headerAlign: "center",
		align: "center",
		renderCell: (params) => {
			// console.log(params);
			return <>{params.row.new_dis}%</>;
		},
	},
	// {
	// 	field: "new_st",
	// 	headerName: "AVG ST",
	// 	width: 100,
	// 	headerAlign: "center",
	// 	align: "center",
	// 	renderCell: (params) => {
	// 		// console.log(params);
	// 		return <>{params.row.new_st}%</>;
	// 	},
	// },
	{
		field: "total_opt",
		headerName: "NEW OPTIONS",
		minWidth: 95,
		flex: 1,
		headerAlign: "center",

		renderCell: (params) => {
			// console.log(params);
			return <>{params.row?.total_opt}</>;
		},
	},
	// {
	// 	field: "new_opt",
	// 	headerName: "NEW OPTIONS",
	// 	width: 95,
	// 	headerAlign: "center",

	// 	renderCell: (params) => {
	// 		// console.log(params);
	// 		return <>{params.row?.new_opt}</>;
	// 	},
	// },
	// {
	// 	field: "new_opt",
	// 	headerName: "NEW OPTIONS",
	// 	width: 95,
	// 	headerAlign: "center",

	// 	renderCell: (params) => {
	// 		// console.log(params);
	// 		return <>{params.row?.new_opt}</>;
	// 	},
	// },
	{ field: "new_asp", headerName: "AVG SP", minWidth: 100, flex: 1, headerAlign: "center", align: "center" },
	{
		field: "new_nsv",
		headerName: "TOTAL SP",
		minWidth: 100,
		flex: 1,
		headerAlign: "center",
		align: "center",
		renderCell: ({ row }) => {
			return <InLakhsDisplay number={row.new_nsv} sx={{ fontWeight: "normal" }} />;
		},
	},
	{
		field: "status",
		align: "center",
		headerName: "Status",
		headerAlign: "center",
		align: "center",
		minWidth: 100,
		flex: 1,
		renderCell: (params) => {
			const value = Math.round((+params.row.current_count / +params.row.current_count) * 100);
			return <CircularProgressWithLabel value={+value ? value : 0} />;
		},
	},

	{
		field: "is_submitted",
		headerName: "SUBMIT STATUS",
		minWidth: 120,
		flex: 1,
		headerAlign: "center",
		align: "center",
		renderCell: (params) => {
			// console.log(params);
			return <>{params.row.is_submitted ? "Submitted" : "Pending"}</>;
		},
	},
];

function BusinessPlanning() {
	const [modalOpen, setModalOpen] = useState(false);
	const [planInfoModalOpen, setPlanInfoModalOpen] = useState(false);
	const [season, setSeason] = useState("select");
	const [year, setYear] = useState(0);
	const [bpLocal, setBpLocal] = useState([]);
	const [bpLoading, setBpLoading] = useState(false);
	const { user } = AuthState();

	const { allBp, setAllBp, selectedBp, setSelectedBp, selectedStore, setSelectedStore } = BusinessPlanState();

	const { setSnackBar, snackBar, setSnackBarOpen } = GlobalState();

	const date = new Date();
	useEffect(() => {
		const fetch = async () => {
			setBpLoading(true);
			try {
				await axios.get("/api/business_plan").then((res) => {
					setAllBp(res.data.business_plan);
					setBpLocal(res.data.business_plan);
				});
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Network Error",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			} finally {
				setBpLoading(false);
			}
		};
		fetch();
	}, []);

	useEffect(() => {
		clearSeasonFilter();
	}, [allBp]);
	// useEffect(() => {
	// 	if (selectedChannel) scrollToStores();
	// }, [selectedBp]);

	const clearSeasonFilter = () => {
		setSeason("select");
		setYear(0);
		allBp ? setBpLocal(allBp) : setAllBp([]);
	};
	const scrollToStores = () => {
		window.scrollTo({ top: 700, behavior: "smooth" });
	};

	const handlePlanSelect = (bp) => {
		scrollToStores();
		setSelectedBp(bp);
	};

	const handleFilterSeasonChange = (season) => {
		setSeason(season);
		if (season !== "select") {
			if (year !== 0) setBpLocal(allBp.filter((row) => row.season === season && row.year === year));
			else setBpLocal(allBp.filter((row) => row.season === season));
		} else {
			if (year !== 0) setBpLocal(allBp.filter((row) => row.year === year));
			else setBpLocal(allBp);
		}
	};
	const handleFilterYearChange = (year) => {
		setYear(year);
		if (year !== 0) {
			if (season !== "select") setBpLocal(allBp.filter((row) => row.season === season && row.year === year));
			else setBpLocal(allBp.filter((row) => row.year === year));
		} else {
			if (season !== "select") setBpLocal(allBp.filter((row) => row.season === season));
			else setBpLocal(allBp);
		}
	};

	// const modalStyle = {
	const modalStyle = {
		width: 250,
		bgcolor: "background.paper",
		boxShadow: 24,
		p: 2,
		borderRadius: 2,
	};
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const id = open ? "simple-popper" : undefined;
	const sectionCardSx = {
		width: "100%",
		backgroundColor: "white",
		border: `1px solid ${grey[300]}`,
		borderRadius: 3,
		boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
		overflow: "hidden",
	};
	const dataGridSx = {
		border: "none",
		width: "100%",
		"& .MuiDataGrid-columnHeaders": {
			background: "linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)",
			borderBottom: `1px solid ${grey[300]}`,
		},
		"& .MuiDataGrid-columnHeader": {
			py: 1,
		},
		"& .MuiDataGrid-columnHeaderTitle": {
			fontWeight: 700,
			fontSize: "0.76rem",
			letterSpacing: "0.08em",
			color: grey[800],
			textTransform: "uppercase",
			whiteSpace: "normal",
			lineHeight: 1.2,
			textAlign: "center",
		},
		"& .MuiDataGrid-cell": {
			borderBottom: `1px solid ${grey[200]}`,
		},
		"& .MuiDataGrid-row": {
			cursor: "pointer",
		},
		"& .MuiDataGrid-footerContainer": {
			borderTop: `1px solid ${grey[300]}`,
		},
	};

	return (
		<Stack spacing={4} maxWidth="1280px" margin="auto" px={{ xs: 2, md: 3 }} pb={4}>
			{/* heading */}
			<Box display="flex" flexWrap="wrap" rowGap={2} alignItems="center" pt={4} justifyContent="space-between">
				<Box>
					<Typography variant="h3">Business Plan</Typography>
				</Box>
				{user && user.role[custom.RSM.key] !== true && (
					<Button
						variant="contained"
						aria-describedby={id}
						sx={{ height: "50px", px: 3, borderRadius: 2 }}
						startIcon={<AddRoundedIcon />}
						onClick={(e) => {
							setModalOpen(true);
							setAnchorEl(anchorEl ? null : e.currentTarget);
						}}>
						New Plan
					</Button>
				)}
				<Popper id={id} open={open} anchorEl={anchorEl} placement="bottom-end">
					<Box sx={modalStyle}>
						<CreateBusinessPlan setModalOpen={setModalOpen} setAnchorEl={setAnchorEl} scrollToStores={scrollToStores} />
					</Box>
				</Popper>
			</Box>

			<Box sx={sectionCardSx}>
				{/* filter box */}
				<Box
					display="flex"
					flexWrap="wrap"
					rowGap={2}
					columnGap={2}
					alignItems="center"
					justifyContent="space-between"
					p={{ xs: 2, md: 3 }}
					borderBottom={`1px solid ${grey[300]}`}>
					<Box>
						<Typography variant="h6">All Plans</Typography>
						<Typography variant="body2" color="text.secondary">
							Select a plan to open its store-level business planning grid.
						</Typography>
					</Box>
					<Box
						display="flex"
						flexWrap="wrap"
						columnGap={1}
						rowGap={1}
						alignItems="center"
						sx={{ background: grey[100] }}
						p={1.25}
						borderRadius={2}>
						<Typography>Filter</Typography>
						<Select size="small" value={season} onChange={(e) => handleFilterSeasonChange(e.target.value)}>
							<MenuItem value={"select"}>Season</MenuItem>
							<MenuItem value={"AW"}>AW</MenuItem>
							<MenuItem value={"SS"}>SS</MenuItem>
						</Select>
						<Select
							size="small"
							value={year}
							MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
							onChange={(e) => handleFilterYearChange(e.target.value)}>
							<MenuItem value={0}>Year</MenuItem>

							<MenuItem value={date.getFullYear()}>{date.getFullYear()}</MenuItem>

							{[1, 2, 3, 4].map((row) => (
								<MenuItem key={row} value={date.getFullYear() + row}>
									{date.getFullYear() + row}
								</MenuItem>
							))}
						</Select>
						<Button variant="contained" onClick={clearSeasonFilter}>
							Clear
						</Button>
					</Box>
				</Box>

				<Box width="100%" p={{ xs: 1, md: 2 }} sx={{ overflowX: "auto" }}>
					<DataGrid
						rows={bpLocal || []}
						columns={bpTablecolumns}
						loading={bpLoading}
						autoHeight={false}
						sx={{ ...dataGridSx, minHeight: 420, minWidth: 0 }}
						rowHeight={40}
						showCellVerticalBorder
						onRowClick={(params, e) => handlePlanSelect(params.row)}
						initialState={{
							pagination: {
								paginationModel: { pageSize: 20 },
							},
						}}
						disableRowSelectionOnClick
						pageSizeOptions={[20, 50]}
						slotProps={{
							loadingOverlay: {
								variant: "circular-progress",
								noRowsVariant: "circular-progress",
							},
						}}
					/>
				</Box>
			</Box>

			<div>{selectedBp ? <StoresTable key={selectedBp?.id || selectedBp?.name} /> : <></>}</div>
			{/* create bp modal */}
			{/* <Modal
				sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
				open={modalOpen}
				onClose={() => setModalOpen(false)}>
				<Box sx={modalStyle}>
					<CreateBusinessPlan setModalOpen={setModalOpen} scrollToStores={scrollToStores} />
				</Box>
			</Modal> */}
			{/* Bp Info Modal */}
			<Modal
				sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
				open={planInfoModalOpen}
				onClose={() => setPlanInfoModalOpen(false)}>
				<Stack sx={modalStyle}>
					<Box>
						<Box display="flex">
							<Typography variant="h6" pr={2}>
								AW-23 Plan
							</Typography>
							<CircularProgressWithLabel value={20} />
						</Box>
						<Box display="flex">
							<Typography variant="subtitle1" pr={2}>
								total qty:0
							</Typography>
							<Typography variant="subtitle1" pr={2}>
								total mrp:0
							</Typography>
						</Box>
					</Box>
					<Box display="flex" alignItems="center" pt={2}>
						<Typography variant="subtitle2" pr={2} color="text.secondary">
							EBO
						</Typography>
						<Typography variant="subtitle1" pr={2}>
							total qty:0
						</Typography>
						<Typography variant="subtitle1" pr={2}>
							total mrp:0
						</Typography>
						<CircularProgressWithLabel value={20} />
					</Box>
					<Box display="flex" alignItems="center" pt={2}>
						<Typography variant="subtitle2" pr={2} color="text.secondary">
							MBO
						</Typography>
						<Typography variant="subtitle1" pr={2}>
							total qty:0
						</Typography>
						<Typography variant="subtitle1" pr={2}>
							total mrp:0
						</Typography>
						<CircularProgressWithLabel value={20} />
					</Box>
					<Box display="flex" alignItems="center" pt={2}>
						<Typography variant="subtitle2" pr={2} color="text.secondary">
							LFS
						</Typography>
						<Typography variant="subtitle1" pr={2}>
							total qty:0
						</Typography>
						<Typography variant="subtitle1" pr={2}>
							total mrp:0
						</Typography>
						<CircularProgressWithLabel value={20} />
					</Box>
				</Stack>
			</Modal>
		</Stack>
	);
}

export default BusinessPlanning;
